export function calculateCVSS({
  attackVector,
  attackComplexity,
  privilegesRequired,
  userInteraction,
  confidentiality,
  integrity,
  availability,
}) {
  const AV_VALUES = { N: 0.85, A: 0.62, L: 0.55, P: 0.2 };
  const AC_VALUES = { L: 0.77, H: 0.44 };
  const PR_VALUES = { N: 0.85, L: 0.68, H: 0.5 };
  const UI_VALUES = { N: 0.85, R: 0.62 };
  const IMPACT_VALUES = { H: 0.56, L: 0.22, N: 0 };

  const av = AV_VALUES[attackVector];
  const ac = AC_VALUES[attackComplexity];
  const pr = PR_VALUES[privilegesRequired];
  const ui = UI_VALUES[userInteraction];
  const c = IMPACT_VALUES[confidentiality];
  const i = IMPACT_VALUES[integrity];
  const a = IMPACT_VALUES[availability];

  const impact = 1 - (1 - c) * (1 - i) * (1 - a);
  const exploitability = av * ac * pr * ui;
  const baseScore =
    impact <= 0
      ? 0
      : Math.min(10, (impact + exploitability) * (impact >= 0.7 ? 1.08 : 1));

  return { baseScore: baseScore.toFixed(1), impact, exploitability };
}
